var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mt-3" }, [
    _c("h1", [_vm._v("Reset Password")]),
    _c("form", { staticClass: "ms-4" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("div", { staticClass: "mb-3" }, [
          _c(
            "label",
            {
              staticClass: "form-label float-left",
              attrs: { for: "inputAddress" },
            },
            [_vm._v("Password")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password",
              },
            ],
            staticClass: "form-control ms-1",
            attrs: {
              type: "password",
              id: "inputAddress",
              placeholder: "Enter new password",
            },
            domProps: { value: _vm.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.password = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "mb-3" }, [
          _c(
            "label",
            {
              staticClass: "form-label float-left",
              attrs: { for: "inputAddress" },
            },
            [_vm._v("Password Confirmation")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.passwordConfirm,
                expression: "passwordConfirm",
              },
            ],
            staticClass: "form-control ms-1",
            attrs: {
              type: "password",
              id: "inputAddress",
              placeholder: "Enter new password",
            },
            domProps: { value: _vm.passwordConfirm },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.passwordConfirm = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _c(
        "button",
        {
          staticClass: "btn btnAccent",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.reset()
            },
          },
        },
        [_vm._v("Submit")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }